import React from 'react';
import { Link } from 'react-router-dom';
import './HeaderFooter.css';

export default function GlobalFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div style={{maxWidth: '1200px', margin: '0 auto'}}>
        <div className="footer-top">
          
          {/* Brand Column */}
          <div className="footer-brand">
            {/* 2. FIX FOOTER LOGO LINK (Logo goes to '/') */}
            <Link to="/" className="footer-logo" aria-label="AI Search Advisers Home" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
              <div style={{ width: '28px', height: '28px', background: 'linear-gradient(to bottom right, #FEAB3D, #e8960a)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#021426" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>
              </div>
              <div style={{ fontFamily: 'Fraunces, serif', fontSize: '1.25rem', fontWeight: 700, color: 'white' }}>AI Search <span style={{ color: '#FEAB3D' }}>Adviser</span></div>
            </Link>
            <p className="footer-tagline" style={{ marginBottom: '1.5rem' }}>
              Understand how AI systems see your business &mdash; and what to improve next.
            </p>
            <Link to="/scan" style={{ display: 'inline-block', background: 'var(--peach)', color: 'var(--midnight)', padding: '0.45rem 1rem', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 600, textDecoration: 'none' }}>
              Run My Free Audit &rarr;
            </Link>
          </div>
          
          {/* Product Column */}
          <div className="footer-col">
            <h6>Product</h6>
            <Link to="/">Home</Link>
            <Link to="/learn-more">Learn More</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/blogs">Blogs & Insights</Link>
            <Link to="/scan">Free Audit</Link>
          </div>
          
          {/* Legal Column */}
          <div className="footer-col">
            <h6>Legal</h6>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-preferences'))}
              style={{ background: 'none', border: 'none', color: 'rgba(255, 255, 255, 0.55)', cursor: 'pointer', padding: 0, textAlign: 'left', font: 'inherit', fontSize: '0.87rem', display: 'block' }}
              onMouseOver={(e) => e.target.style.color = 'var(--peach)'}
              onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.55)'}
            >
              Cookie Settings
            </button>
          </div>

          {/* Contact Column */}
          <div className="footer-col">
            <h6>Contact</h6>
            <a href="mailto:info@aisearchadvisers.com">info@aisearchadvisers.com</a>
          </div>

        </div>
        <div className="footer-bottom">
          <span>&copy; {currentYear} AI Search Advisers. All rights reserved.</span>
          <span style={{ display: 'flex', gap: '1rem' }}>
            <Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy</Link>
            <Link to="/terms-of-service" style={{ color: 'inherit', textDecoration: 'none' }}>Terms</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
